import "./App.css";
import React, { useState, useEffect } from "react";
import Game from "./components/game";
import KeyboardInputController from "./classes/input/keyboardInputController";

function App() {
  const [inputController] = useState(new KeyboardInputController());

  useEffect(() => {
    inputController.plugin();
  }, [inputController]);

  return (
    <div className="App">
      <Game inputController={inputController} />
    </div>
  );
}

export default App;
